export const server = "https://ecommerce-web-api.vercel.app/api/v2";


